import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  Row,
} from 'reactstrap';
import { ReactComponent as CorrectSign } from '../../assets/images/svg/correct-sign.svg';
import StyledButton from '../../components/Common/StyledButton';
import { formatNumberWithCommasAndDecimal } from '../Invoices/invoiceUtil';
// import { ReactComponent as Delete } from "../../assets/images/svg/delete-button.svg";
import { Cancel, CheckCircle, Print } from '@mui/icons-material';
import HistoryIcon from '@mui/icons-material/History';
import { connect } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import generatePDF, { Margin, Options, Resolution } from 'react-to-pdf';
import ApproveConfirm from '../../components/CustomComponents/ApproveConfirm';
import PublishConfirm from '../../components/CustomComponents/PublishConfirm';
import RequirePermission from '../../routes/middleware/requirePermission';
import RequireUserType from '../../routes/middleware/requireUserType';
import {
  convertToSalesOrderReq,
  getPurchaseOrderAuditDetailsReq,
  getPurchaseOrderDetailsReq,
  purchaseOrderStatusChangeReq,
} from '../../service/purchaseService';
import { setBreadcrumbItems } from '../../store/Breadcrumb/actions';
import {
  MODULES_ENUM,
  PERMISSIONS_ENUM,
  USER_TYPES_ENUM,
} from '../../utility/constants';
import OrderStatusRenderer from './OrderStatusRenderer';
// import { IconButton, Tooltip } from "@mui/material";
// import Hero from "../../components/Common/Hero";
import { toast } from 'react-toastify';
import { getAgreement } from '../../api';
import Spinners from '../../components/Common/Spinner';
import { formatDate } from '../../utility/formatDate';
import getPaymentTerm from '../../utility/getPaymentTerm';
import PdfComponent from './PdfComponent';

const PurchaseOrderDetails = (props) => {
  const { id, version, auditId } = useParams();
  const isAuditTrail = !!version;
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  const [auditOrderInfo, setAuditOrderInfo] = useState({});
  const [status, setStatus] = useState('');
  const [publishModal, setPublishModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("published");
  const [paymentTerms, setPaymentTerms] = useState()
  const [showWatermark, setShowWatermark] = useState(false);
  const [loading, setLoading] = useState(true);

  const statusToTextMap = {
    draft: 'Draft',
    published: 'Publish',
    sent: 'Approve',
    accepted: 'Accept',
    rejected: 'Reject',
    declined: 'Declined',
  };

  async function handlePurchaseOrderStatusChange(status) {
    const body = {
      purchaseOrderId: id,
      status: status,
    };
    setIsButtonLoading(true);
    if (status === 'accepted') {
      try {
        const response = await convertToSalesOrderReq({
          purchaseOrderId: body.purchaseOrderId,
        });
        if (response.success) {
          toast.success('Purchase order Accepted');
          setStatus(status);
        } else {
          const { message } = response;
          toast.error(message || 'Sorry, something went wrong!');
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error('Bad Request:', error);
          toast.error('Something went wrong');
          // Handle the 400 error here, e.g., show an error message to the user
        } else {
          console.error('Failed to convert to sales order', error);
          toast.error('Something went wrong');
        }
      } finally {
        setIsButtonLoading(false);
        setApproveModal(false);
      }
    } else {
      try {
        const response = await purchaseOrderStatusChangeReq(body);
        if (response.success) {
          toast.success(`Purchase Order ${statusToTextMap[status]}`)
          setStatus(status);
        } else {
          const { message } = response;
          toast.error(message || 'Sorry, something went wrong!');
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error('Bad Request:', error);
          toast.error('Something went wrong');
          // Handle the 400 error here, e.g., show an error message to the user
        } else {
          console.error('Failed to change purchase order status:', error);
          toast.error('Something went wrong');
        }
      } finally {
        setIsButtonLoading(false);
        setApproveModal(false);
      }
    }
  }

  const submitPurchaseOrder = () => {
    setSelectedStatus('sent');
    setApproveModal(true);
  };

  const rejectPurchaseOrder = () => {
    setSelectedStatus('rejected');
    setApproveModal(true);
    console.log('PURCHASE ORDER REJECTED');
  };

  const acceptPurchaseOrder = () => {
    setSelectedStatus('accepted');
    setApproveModal(true);
    //setStatus('accepted');
    //setSelectedStatus('accepted');
    //TODO: The handlePurchaseOrderStatusChange(); is taking the old value of selectedStatus
    //TODO: ADD BUTTON LOADER, IN THE BACKEND ADD ZOHO SYNC API CALL
  };

  const declinePurchaseOrder = () => {
    setSelectedStatus('declined');
    setApproveModal(true);
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    if (newStatus === 'published') {
      setPublishModal(true);
    }
  };

  const getAuditPurchaseOrderDetails = async () => {
    const response = await getPurchaseOrderDetailsReq(id);
    const rawData = response?.data;
    console.log(rawData)
    setAuditOrderInfo(rawData)
  };

  const getPurchaseOrderDetails = async () => {
    const response = isAuditTrail
      ? await getPurchaseOrderAuditDetailsReq(id, auditId)
      : await getPurchaseOrderDetailsReq(id);
    const rawData = response?.data;
    const purchaseOrder = isAuditTrail && rawData?.snapshot
      ? {
        ...rawData,
        ...(rawData.snapshot.purchaseOrderDetails || {}),
        items: rawData.snapshot.items || [],
      }
      : rawData;

    setItemsData(purchaseOrder?.items);
    setOrderInfo(purchaseOrder);
    setStatus(purchaseOrder?.POStatus);
    if (purchaseOrder?.POStatus !== 'draft') {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

    let subTotal = 0;
    let totalQuantity = 0;
    let gstTotal = 0;

    (purchaseOrder.items || []).forEach((item) => {
      subTotal += item.unitPrice * item.quantity;
      totalQuantity += item.quantity;
      item.taxes.forEach((tax) => {
        gstTotal += (item.unitPrice * item.quantity * tax.taxPercentage) / 100;
      });
    });

    const total = subTotal + gstTotal;

    setOrderInfo({
      ...purchaseOrder,
      subTotal,
      totalQuantity,
      gstTotal,
      total,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        await Promise.all([
          getAuditPurchaseOrderDetails(),
          getPurchaseOrderDetails(),
        ]);
      } catch (e) {
        console.error("Error fetching PO details", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, version, auditId]);

  const getAgreementData = async (id) => {
    try {
      const data = { clientId: id }
      const res = await getAgreement(data);

      setPaymentTerms(res.payload.paymentTerms)
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    const poNumber = isAuditTrail
      ? auditOrderInfo?.purchaseOrderNumber
      : orderInfo?.purchaseOrderNumber;

    if (!poNumber) return;

    const breadcrumbItems = isAuditTrail
      ? [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Purchase Orders", link: "/purchase-orders" },
        {
          title: poNumber,
          link: `/purchase-orders/${id}/trail`,
        },
        { title: version, link: "#" },
      ]
      : [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Purchase Orders", link: "/purchase-orders" },
        { title: poNumber, link: "#" },
      ];

    props.setBreadcrumbItems("Purchase Order", breadcrumbItems);
  }, [orderInfo, auditOrderInfo, version, id]);

  useEffect(() => {
    if (orderInfo.clientId) {
      getAgreementData(orderInfo.clientId);
    }
  }, [orderInfo.clientId]);

  const options = {
    filename: 'Purchase Order.pdf',
    method: 'save',
    resolution: Resolution.HIGH,
    page: {
      margin: Margin.MEDIUM,
      format: 'A4',
      orientation: 'portrait',
    },
    canvas: {
      mimeType: 'image/jpeg',
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
      canvas: {
        useCORS: true,
      },
    },
  };

  const getTargetElement = () => document.getElementById("print-container");
  const downloadPDF = async () => {
    setShowWatermark(true);

    setTimeout(async () => {
      await generatePDF(getTargetElement, options);
      setShowWatermark(false);
    }, 300);
  };


  const billingAddress = orderInfo.billing?.address;
  const shippingAddress = orderInfo.shipping?.address;

  const getAddressValue = (address) => {
    if (!address) return '';
    return (
      <>
        {address.addressLine1},<br />
        {address.addressLine2 || ''},<br />
        {address.state}&nbsp;{address.city}&nbsp;-&nbsp;{address.pincode}.
      </>
    );
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <Spinners />
      </div>
    );
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <div
          className="d-flex align-items-center gap-2"
          style={{
            position: 'absolute',
            top: -50,
            right: 10,
          }}
        >
          <Modal
            centered
            toggle={() => setPublishModal(!publishModal)}
            isOpen={publishModal}
          >
            <PublishConfirm
              setPublishModal={setPublishModal}
              setStatus={setStatus}
              id={id}
            />
          </Modal>
          <Modal
            centered
            toggle={() => setApproveModal(!approveModal)}
            isOpen={approveModal}
          >
            <ApproveConfirm
              setApproveModal={setApproveModal}
              handlePurchaseOrderStatusChange={handlePurchaseOrderStatusChange}
              status={selectedStatus}
              isButtonLoading={isButtonLoading}
            />
          </Modal>

          {status === 'draft' ? (
            <>
              <PdfComponent data={{ orderInfo, itemsData, paymentTerms }} />
              <select
                className="form-select focus-width"
                name="status"
                disabled={isDisabled}
                value={status}
                onChange={handleStatusChange}
              >
                <option value="draft">Draft</option>
                <option value="published">Published</option>
              </select>
              <Link to="edit" className="w-md btn btn-primary">
                Edit
              </Link>
            </>
          ) : (
            <>
              {OrderStatusRenderer({ value: status })}

              <RequirePermission
                module={MODULES_ENUM.ORDERS}
                permission={PERMISSIONS_ENUM.CREATE}
              >
                <div className="d-flex align-items-center gap-2">
                  {!isAuditTrail && <PdfComponent data={{ orderInfo, itemsData, paymentTerms }} />}

                  <Link
                    to={`/purchase-orders/${id}/trail`}
                    className="btn btn-outline-secondary d-flex align-items-center gap-1"
                  >
                    <HistoryIcon fontSize="small" />
                    History
                  </Link>
                </div>
              </RequirePermission>
            </>
          )}
          <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              {!isAuditTrail && status === 'published' && (
                <StyledButton
                  color={'success'}
                  className={'w-md mx-2'}
                  onClick={submitPurchaseOrder}
        >
          <CorrectSign className="me-1" />
          Accept
        </StyledButton>
      )}
            </RequirePermission>
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              {!isAuditTrail && status === 'published' && (
                <StyledButton
                  color={'danger'}
                  className={'w-md mx-2'}
                  onClick={rejectPurchaseOrder}
      >
        <Cancel className="me-1" />
        Decline
      </StyledButton>
    )}
            </RequirePermission>
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
            {!isAuditTrail && status === 'sent' && (
              <StyledButton
                color={'success'}
                className={'w-md'}
                onClick={acceptPurchaseOrder}
              >
                <CorrectSign className="me-1" />
                Accept
              </StyledButton>
            )}
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
            {!isAuditTrail && status === 'sent' && (
              <StyledButton
                color={'danger'}
                className={'w-md mx-2'}
                onClick={declinePurchaseOrder}
              >
                <Cancel className="me-1" />
                Decline
              </StyledButton>
            )}
          </RequireUserType>
        </div>
      </div>
      <div id="print-container" style={{ position: "relative" }}>
        {showWatermark && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
              transformOrigin: "center",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "80px",
              color: "rgba(150,150,150,0.2)",
              fontWeight: "bold",
              pointerEvents: "none",
              zIndex: 1000,
              whiteSpace: "nowrap",
            }}
          >
            {status?.toUpperCase()}
          </div>
        )}
    <Card>
      <CardBody>
        <div className="card-content">
          <div className="details">
                <h3 className="fw-bolder">{!isAuditTrail ? orderInfo.clientName : auditOrderInfo?.clientName}</h3>
    <p className="m-0">{orderInfo.billing?.branchName}</p>
    <p className="m-0">
      <>{getAddressValue(billingAddress)}</>
    </p>
    <p className="m-0">{orderInfo.billing?.contact}</p>
  </div>
  <div>
    <span className="purchase-order">Purchase Order</span>
    <br />
    <span className="purchase-order-no">
      {!isAuditTrail ? orderInfo.purchaseOrderNumber : auditOrderInfo?.purchaseOrderNumber}
    </span>
  </div>
            </div >
          </CardBody >
        </Card >

  <Row className="mb-3">
    <div style={{ position: 'relative' }}>
      <Row className="equal-height-cards">
        <Col xl="7">
          <Card>
            <CardBody>
              <Row className="py-2 border-bottom">
                <Col>Order Date</Col>
                <Col>{formatDate(!isAuditTrail ? orderInfo?.createdAt : auditOrderInfo?.createdAt)}</Col>
              </Row>
              <Row className="py-2 border-bottom">
                <Col>Payment Terms</Col>
                <Col>{!isAuditTrail ? getPaymentTerm(paymentTerms) : '-'}</Col>
              </Row>
              <Row className="py-2 border-bottom">
                <Col>Sales Order No.</Col>
                <Col>
                  {orderInfo?.salesOrderNumber
                    ? orderInfo?.salesOrderNumber
                    : '-'}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
        <Col xl="5">
          <Card>
            <CardBody className="d-flex flex-column gap-2">
              <div style={{ flex: 1 }} className="border-bottom">
                <p className="fw-lighter m-0">Vendor Address</p>
                <h5 className="fw-medium text-uppercase m-0">
                  Bansi Office Solutions Private Limited #1496, 19th Main
                  Road, Opp Park Square Apartment, HSR Layout, Bangalore
                  Karnataka 560102, India
                </h5>
              </div>
              <div style={{ flex: 1 }}>
                <p className="fw-lighter m-0">Shipping Address</p>
                <h5 className="fw-medium text-uppercase m-0">
                        <>{getAddressValue(shippingAddress)}</>
                      </h5 >
                    </div >
                  </CardBody >
                </Card >
              </Col >
            </Row >
  <Row>
    <Col xl="8">
      <Card className="mt-3" style={{ height: 'fit-content' }}>
        <CardHeader>Sales Information</CardHeader>
        <CardBody>
          <Row className="py-2 border-bottom">
            <Col xl="4">Item & Description</Col>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              <Col xl="3">Rate</Col>
            </RequirePermission>
            <Col xl="3">Ordered</Col>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              <Col xl="2">Amount</Col>
            </RequirePermission>
          </Row>
                    {itemsData &&
                      itemsData.map((item, index) => {
                        const itemTitle =
                          item?.itemId?.title ||
                          item?.title ||
                          item?.name ||
                          item?.itemName ||
                          '';
                        const itemDescription =
                          item?.itemId?.description ||
                          item?.description ||
                          item?.itemDescription ||
                          '';

                        return (
                          <Row
                            key={index}
                            className="py-2 border-bottom align-items-center"
                          >
                            <Col xl="4">
                              <h6
                                style={{
                                  margin: 0,
                                  fontSize: '14px',
                                  paddingTop: '3px',
                                }}
                              >
                                {itemTitle}
                              </h6>
                              <span
                                style={{
                                  margin: 0,
                                  fontSize: '12px',
                                  color: 'grey',
                                  paddingTop: '2px',
                                }}
                              >
                                {itemDescription}
                              </span>
                            </Col>
                            <RequirePermission
                              module={MODULES_ENUM.ORDERS}
                              permission={PERMISSIONS_ENUM.CREATE}
                            >
                              <Col xl="3">
                                <h6 className="m-0">
                                  {formatNumberWithCommasAndDecimal(
                                    item.unitPrice,
                                  )}
                                </h6>
                              </Col>
                            </RequirePermission>
                            <Col xl="3">
                              {item.quantity}&nbsp;{item.itemUnit}
                            </Col>
                            <RequirePermission
                              module={MODULES_ENUM.ORDERS}
                              permission={PERMISSIONS_ENUM.CREATE}
                            >
                              <Col xl="2">
                                <h6 className="m-0">
                                  {formatNumberWithCommasAndDecimal(
                                    item.unitPrice * item.quantity,
                                  )}
                                </h6>
                              </Col>
                            </RequirePermission>
                          </Row>
                        );
                      })}
                  </CardBody >
                </Card >
              </Col >
  <RequirePermission
    module={MODULES_ENUM.ORDERS}
    permission={PERMISSIONS_ENUM.CREATE}
  >
    <Col xl="4">
      <Card className="mt-3">
        <CardHeader>Order Info</CardHeader>
        <CardBody
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h5
              className="mb-0"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>Sub Total :</span>
              <span>
                {formatNumberWithCommasAndDecimal(
                  orderInfo.subTotal,
                )}
              </span>
            </h5>
            <div style={{ fontSize: '0.7rem' }}>
              Total Quantity: {orderInfo.totalQuantity}
            </div>
            <hr />
            <h5
              className="mb-0"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>GST :</span>
              <span>
                {formatNumberWithCommasAndDecimal(
                  orderInfo.gstTotal,
                )}
              </span>
            </h5>
            <hr />
            <h5
              className="mb-0"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>Total :</span>
              <span>
                {formatNumberWithCommasAndDecimal(orderInfo.total)}
              </span>
            </h5>
          </div>
        </CardBody>
      </Card>
    </Col>
  </RequirePermission>
            </Row >
  <Row>
    <Col xl="8">
      <Card className="mt-3">
        <CardHeader>Terms & Conditions</CardHeader>
        <CardBody>
                    {orderInfo.terms ? (
                      <div style={{ whiteSpace: 'pre-wrap' }}>
                        {orderInfo.terms}
                      </div>
                    ) : (
                      <span style={{ color: 'grey' }}>
                        No Terms & Conditions
                      </span>
                    )}
                  </CardBody >
                </Card >
              </Col >
            </Row >
          </div >
        </Row >
      </div >
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(PurchaseOrderDetails);
